import React from 'react'
import NavItem from '../../Layout/NavItem'
import { NavItemProps } from '../../Layout/NavItem'

const StaffNavItem: React.FC<NavItemProps> = (props) =>
  <NavItem {...props} base='staff' />

export default StaffNavItem